// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3ygPQ","actions":"GroupTable_actions__3UO8Z","deleteModalFooter":"GroupTable_deleteModalFooter__tBqNB"};